import type { Ring } from '../geo/types';
import type { Landmark } from '../data/types';

export type DiscoveryTheme = 'trade' | 'city' | 'care';

/** A place of the city a visitor can find, told for a child. The words are English and are the
 *  keys of their Dutch. Every fact in them is in the layout's record of the landmark or in the
 *  in-city source note named here; the place, its certainty and its sources are the layout's. */
export interface Discovery {
  readonly id: string;
  readonly theme: DiscoveryTheme;
  readonly name: string;
  /** Shown until the place is found: what to look for. */
  readonly clue: string;
  /** Shown once it is found. */
  readonly text: string;
  /** A source of the in-city register whose note also stands behind the words. */
  readonly source?: string;
}

export interface DiscoveryPlace extends Discovery {
  readonly footprint: Ring;
  readonly confidence: Landmark['confidence'];
  /** The titles of the sources the layout records for this landmark. */
  readonly sources: readonly string[];
}

export const THEMES: Readonly<Record<DiscoveryTheme, string>> = {
  trade: 'Trade and work',
  city: 'City and defence',
  care: 'Faith and care',
};

export const CERTAINTY: Readonly<Record<Landmark['confidence'], string>> = {
  high: 'Sure: the building still stands or was measured.',
  medium: 'Fairly sure: an old map or a history book gives its place or size.',
  low: 'A careful guess: its size or form is estimated.',
};
